// Wire shape of the PUBLIC status page (`GET /api/status`, web `/status`).
//
// This is the only health surface a person with no session can read, so the
// shape is deliberately thin: one coarse state word for the service, and one
// state word for each component group. It carries no version, no host name,
// no error text and no count of client data. The detail stays behind the
// admin-gated system-status board (`system-status.ts`).

import { z } from 'zod';

/**
 * operational — every signal in the group is healthy.
 * degraded    — at least one signal is stale or carries failures.
 * down        — at least one signal is unreachable.
 */
export const publicStatusStateSchema = z.enum(['operational', 'degraded', 'down']);
export type PublicStatusState = z.infer<typeof publicStatusStateSchema>;

export const publicStatusComponentSchema = z.object({
    /** Stable group key, for example 'database' or 'custodian_feeds'. */
    key: z.string(),
    /** Plain public label, for example 'Custodian data feeds'. */
    label: z.string(),
    state: publicStatusStateSchema,
});
export type PublicStatusComponentDto = z.infer<typeof publicStatusComponentSchema>;

export const publicStatusResponseSchema = z.object({
    /** The worst state of the component list. */
    overall: publicStatusStateSchema,
    /** ISO timestamp of the health read behind this answer. */
    checkedAt: z.string(),
    components: z.array(publicStatusComponentSchema),
});
export type PublicStatusResponse = z.infer<typeof publicStatusResponseSchema>;
